module.exports = __webpack_public_path__ + "static/img/pro_01.d152d06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent/pro_01.png
// module id = wCEV
// module chunks = 6